import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { contenteditable: "true" }
const _hoisted_2 = {
  id: "page_0",
  class: "page"
}
const _hoisted_3 = { class: "d-row" }
const _hoisted_4 = { class: "page-footer" }
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "eng-head" }
const _hoisted_8 = { class: "proj-head" }
const _hoisted_9 = { class: "sum-row" }
const _hoisted_10 = { class: "page-footer" }

import { getKey } from "@/common/util";
import { useSettingsStore } from "@/stores/setting";
import { formatLocaleDate } from "@/common/date";
import { reactive } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TSInvoice',
  props: ['data', 'year', 'month', "service"],
  setup(__props) {

const props = __props;
const settingsStore = useSettingsStore();

const state = reactive({
    date: { year: (new Date).getFullYear(), month: (new Date).getMonth() },
    currency: "MXN"
});

const getCurrentPage = (index: number, jndex: number) => {
    let count = 0;
    props.data.engineers.forEach((item: any, i: number) => {
        if (i < index) {
            count += item.engineerActivities.length;
        } else if (i == index) {
            count += jndex + 1;
        }
    });
    return count;
}

const totalPageCount = {
    get: () => {
        let result = 1;
        for (let i = 0; i < props.data.engineers.length; i++) {
            result += props.data.engineers[i].engineerActivities.length;
        }
        return result;
    }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("table", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, "ABB Mexico SA de CV")
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, "Avenida Central No. 310, Parque Logístico,")
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, "C.P. 78395, San Luis Potosí, S.L.P.")
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, "MEXICO")
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, "AME920102SS4")
        ])
      ], -1)),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "red-line" }, null, -1)),
      _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Time sheet for invoicing", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", null, [
          _createElementVNode("tr", null, [
            _cache[0] || (_cache[0] = _createElementVNode("td", null, "Year / Month", -1)),
            _createElementVNode("td", null, _toDisplayString(props.year) + "/" + _toDisplayString(_ctx.$props.month), 1)
          ]),
          _createElementVNode("tr", null, [
            _cache[1] || (_cache[1] = _createElementVNode("td", null, "MXTEC Service name", -1)),
            _createElementVNode("td", null, _toDisplayString(props.service.blServiceName), 1)
          ]),
          _createElementVNode("tr", null, [
            _cache[2] || (_cache[2] = _createElementVNode("td", null, "MXTEC SAP number", -1)),
            _createElementVNode("td", null, _toDisplayString(props.service.sapNumber), 1)
          ])
        ]),
        _createElementVNode("table", null, [
          _createElementVNode("tr", null, [
            _cache[3] || (_cache[3] = _createElementVNode("td", null, "Customer Purchase order", -1)),
            _createElementVNode("td", null, _toDisplayString(props.service?.poNumber), 1)
          ]),
          _createElementVNode("tr", null, [
            _cache[4] || (_cache[4] = _createElementVNode("td", null, "Customer BL PG code", -1)),
            _createElementVNode("td", null, _toDisplayString(props.service?.blpgCode), 1)
          ]),
          _createElementVNode("tr", null, [
            _cache[5] || (_cache[5] = _createElementVNode("td", null, "Customer country", -1)),
            _createElementVNode("td", null, _toDisplayString(_unref(settingsStore).getCountries.find(a => a.id == props.service.countryId)?.name), 1)
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _cache[6] || (_cache[6] = _createElementVNode("h4", null, " Summary by Engineers: ", -1)),
        _createElementVNode("table", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.engineers, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: _unref(getKey)('eng_s', index)
            }, [
              _createElementVNode("td", null, _toDisplayString(item.user?.fullName), 1),
              _createElementVNode("td", null, "Hours: " + _toDisplayString(item.sumHours), 1),
              _createElementVNode("td", null, "Rate: " + _toDisplayString(item.rate?.name), 1),
              _createElementVNode("td", null, "Sum: " + _toDisplayString((item.rate?.value ?? 0) * item.sumHours), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", null, [
        _cache[8] || (_cache[8] = _createElementVNode("h4", null, " Summary by Rate Category: ", -1)),
        _createElementVNode("table", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.rateSummaries, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: _unref(getKey)('rate_s', index)
            }, [
              _createElementVNode("td", null, _toDisplayString(item.rate?.name) + " - " + _toDisplayString(item.rate?.value), 1),
              _createElementVNode("td", null, "Hours: " + _toDisplayString(item.hours), 1),
              _createElementVNode("td", null, "Sum: " + _toDisplayString((item.rate?.value ?? 0) * item.hours), 1)
            ]))
          }), 128)),
          _createElementVNode("tr", null, [
            _cache[7] || (_cache[7] = _createElementVNode("th", null, "Sum invoice total:", -1)),
            _createElementVNode("th", null, _toDisplayString(props.data.rateSummaries.reduce((sum, item) => sum + item.hours, 0)) + " h", 1),
            _createElementVNode("th", null, "MXN " + _toDisplayString(props.data.rateSummaries.reduce((sum, item) => sum + (item.rate?.value ?? 0) * item.hours, 0)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, " 1 / " + _toDisplayString(totalPageCount.get()), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.engineers, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: _unref(getKey)('eng', index + 1),
        id: _unref(getKey)('eng', index + 1)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.engineerActivities, (jtem, jndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: _unref(getKey)('page', index + jndex),
            id: _unref(getKey)('page', (getCurrentPage(index, jndex))),
            class: "page"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h4", null, _toDisplayString(item.user?.fullName), 1),
              _createElementVNode("h4", null, _toDisplayString(state.currency) + " " + _toDisplayString(jtem.dailyActivities.reduce((sum, activity) => sum + (activity.hours ?? 0), 0) * (item.rate?.value ?? 0)), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h4", null, "Customer Project number: " + _toDisplayString(jtem.project?.projectNumber), 1),
              _createElementVNode("h4", null, "Customer Activity number: " + _toDisplayString(jtem.dailyActivities[0].definition.activityNumber), 1)
            ]),
            _createElementVNode("table", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jtem.dailyActivities, (row, jindex) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: _unref(getKey)('row', jindex)
                }, [
                  _createElementVNode("td", null, _toDisplayString(_unref(formatLocaleDate)(row.date)), 1),
                  _createElementVNode("td", null, _toDisplayString(row.hours ?? 0) + " h", 1),
                  _createElementVNode("td", null, _toDisplayString(row.comment), 1)
                ]))
              }), 128)),
              _createElementVNode("tr", null, [
                _cache[12] || (_cache[12] = _createElementVNode("td", null, null, -1)),
                _createElementVNode("td", null, [
                  _createElementVNode("b", null, _toDisplayString(jtem.dailyActivities.reduce((sum, activity) => sum + (activity.hours ?? 0), 0)) + " h", 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("b", null, " Rate: " + _toDisplayString(item.rate?.name) + " - " + _toDisplayString(item.rate?.value), 1),
                    _createElementVNode("b", _hoisted_9, "Sum: " + _toDisplayString(state.currency) + " " + _toDisplayString(jtem.dailyActivities.reduce((sum, activity) => sum + (activity.hours ?? 0), 0) * (item.rate?.value ?? 0)), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(getCurrentPage(index, jndex) + 1) + " / " + _toDisplayString(totalPageCount.get()), 1)
          ], 8, _hoisted_6))
        }), 128))
      ], 8, _hoisted_5))
    }), 128))
  ]))
}
}

})